export default __webpack_public_path__ + "static/media/family.fd2ab0c2.svg";